import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    const tick = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("error"); return; }
      } catch (e) { /* retry */ }
      if (tries >= 10) { setState("timeout"); return; }
      setTimeout(tick, 2000);
    };
    tick();
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="max-w-2xl mx-auto px-6 py-28 text-center">
      {state === "checking" && (
        <>
          <Loader2 className="w-10 h-10 text-[#00e5ff] animate-spin mx-auto" />
          <h1 className="display text-3xl uppercase tracking-tight font-bold mt-6">Confirming payment…</h1>
        </>
      )}
      {state === "paid" && (
        <>
          <CheckCircle2 className="w-12 h-12 text-[#00e5ff] mx-auto" />
          <h1 data-testid="payment-confirmed-heading" className="display text-4xl uppercase tracking-tighter font-bold mt-6">Session booked</h1>
          <p className="text-sm text-zinc-400 mt-4">Your payment cleared and your coach has been notified.</p>
          <Link to="/bookings" data-testid="go-to-bookings-btn" className="inline-block mt-8 bg-[#00e5ff] text-black text-xs font-bold uppercase px-7 py-3.5 hover:bg-[#00b3cc] transition-colors duration-200">View my bookings</Link>
        </>
      )}
      {(state === "error" || state === "timeout") && (
        <>
          <XCircle className="w-12 h-12 text-[#ff3b30] mx-auto" />
          <h1 className="display text-3xl uppercase tracking-tight font-bold mt-6">Payment not confirmed</h1>
          <p className="text-sm text-zinc-400 mt-4">We could not confirm this payment. Check My Bookings in a moment or try again.</p>
          <Link to="/bookings" className="inline-block mt-8 border border-white/25 text-xs uppercase px-7 py-3.5 hover:border-[#00e5ff] hover:text-[#00e5ff] transition-colors duration-200">My bookings</Link>
        </>
      )}
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="max-w-2xl mx-auto px-6 py-28 text-center">
      <XCircle className="w-12 h-12 text-[#ff3b30] mx-auto" />
      <h1 className="display text-4xl uppercase tracking-tighter font-bold mt-6">Checkout cancelled</h1>
      <p className="text-sm text-zinc-400 mt-4">Nothing was charged. Your slot is still open.</p>
      <Link to="/coaches" data-testid="back-to-coaches-btn" className="inline-block mt-8 bg-[#00e5ff] text-black text-xs font-bold uppercase px-7 py-3.5 hover:bg-[#00b3cc] transition-colors duration-200">Back to coaches</Link>
    </div>
  );
}
